// Privacy Policy — localized (pt /privacy, en /en/privacy, es
// /es/privacy). Content lives in src/i18n/legal/privacy.ts; the shared
// LegalDocView renders it with per-locale <head> + hreflang.

import { LegalDocView } from "@/components/marketing/LegalDocView";
import { useLocale } from "@/i18n/LocaleProvider";
import { PRIVACY } from "@/i18n/legal/privacy";

export function PrivacyPage() {
  const locale = useLocale();
  return <LegalDocView page="privacy" doc={PRIVACY[locale]} />;
}
